import { getScoreLabel } from "./assessmentData";

export default function ScoreRing({ score, size = 120, label }) {
  const s = getScoreLabel(score);
  const circumference = 2 * Math.PI * 44;
  return (
    <div className="text-center">
      <div className="relative mx-auto" style={{ width: size, height: size }}>
        <svg className="-rotate-90" width={size} height={size} viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="44" stroke="rgba(255,255,255,0.06)" strokeWidth="6" fill="none" />
          <circle cx="50" cy="50" r="44" stroke={s.color} strokeWidth="6" fill="none"
            strokeDasharray={`${(score / 100) * circumference} ${circumference}`}
            strokeLinecap="round" className="transition-all duration-1000" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="stat-number text-2xl text-white">{score}</span>
        </div>
      </div>
      <p className="text-white text-sm font-semibold mt-2">{label}</p>
      <p className="text-xs mt-0.5" style={{ color: s.color }}>{s.label}</p>
    </div>
  );
}
